import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Interaccion/Details/{id}',
  documento: 'crm',
  filas: ['146'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/InteraccionController.cs',
} satisfies RutaProd;
